import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    makeStyles,
    Menu,
    MenuItem,
    Popover,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography,
} from "@material-ui/core"
import { AddAPhoto, DeleteForever, InfoOutlined, MoreVert } from "@material-ui/icons"
import { useSnackbar } from "notistack"
import { memo, useCallback, useRef, useState } from "react"
import { redimensionarPara300x300 } from "../../../functions/imagens"
import { inativarOpcao } from "../../../services/cardapio"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"
import { useCardapioContext } from "./CardapioContext"
import DialogFTI from "./DialogFTI"
import DisponibilidadeSwitch from "./DisponibilidadeSwitch"

const useStyles = makeStyles(() => ({
    container: {
        padding: "1rem 5px 1rem 0",
    },
    containerImg: {
        margin: "auto",
        width: "100px",
        height: "100px",
        backgroundColor: "#eee",
        border: "2px dashed #ccc",
        cursor: "pointer",
    },
    addAPhoto: {
        margin: "auto",
        display: "block",
        width: "30%",
        height: "30%",
        color: "rgba(0,0,0,0.5)",
    },
    input: {
        display: "none",
    },
    conteudo: {
        margin: "auto",
    },
    botaoExcluir: {
        backgroundColor: "red",
        color: "white",
        "&:hover": {
            backgroundColor: "#FF4D4D",
        },
    },
}))

const ItemAdicional = memo(function ItemAdicional({ produto, passo, item }) {
    const {
        handleExcluirOpcao,
        handleIdsEditar,
        handleCadastrarImagem,
        insumos,
        insumoSelecionado,
        insumosSelecionados,
        fichaTecnica,
        quantidades,
        handleAddInsumo,
        handleDeleteInsumo,
        salvarFt,
        setInsumoSelecionado,
        setQuantidades,
        setAltInsumo,
        buscarFT,
    } = useCardapioContext()

    const setLoading = useLoadingStore(s => s.setLoading)
    const { enqueueSnackbar } = useSnackbar()
    const autorizacao = localStorage.getItem("chaveSistema")
    const configuracoes = useAppStore(s => s.configuracoes)
    const parametros = configuracoes.user.parametros

    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    const fileInputRef = useRef(null)
    const handleDivClick = useCallback(() => {
        fileInputRef.current.click()
    }, [])

    const handleFileChange = useCallback(
        async event => {
            const file = event.target.files[0]

            try {
                const file300 = await redimensionarPara300x300(file)
                const nomeArquivo = file.name
                const idProduto = produto.id
                const idOpcao = item.id
                const idPasso = passo.id

                if (file) {
                    handleIdsEditar(produto.id)
                    handleCadastrarImagem(nomeArquivo, idProduto, idPasso, idOpcao, file300)
                }
            } catch (error) {
                alertStart(`${error}`, "error")
            }
        },
        [produto.id, item.id, passo.id, handleIdsEditar, handleCadastrarImagem, alertStart]
    )

    const classes = useStyles()

    // const handleDragStart = index => {
    //     setDraggingAdicionais(index)
    // }
    // const handleDragEnd = () => {
    //     setDraggingAdicionais(null)
    // }

    const [disponivel, setDisponivel] = useState(item?.ativo)
    const handleChangeDisponibilidadeOpcao = useCallback(async () => {
        setLoading(true)
        const response = await inativarOpcao(item.id, disponivel, autorizacao)
        if (response.retornoErro) {
            console.error(response)
            alertStart(response.mensagem, "error")
        } else {
            setDisponivel(prev => !prev)
            console.warn("inativarOpcao => ", response)
            alertStart("Disponibilidade da opção alterada com sucesso", "success")
        }
        setLoading(false)
    }, [item.id, disponivel, autorizacao, setLoading, alertStart])

    const [tipoProducao, setTipoProducao] = useState(item?.tipoProducao)
    const handleTipoProducao = useCallback(
        e => {
            item.tipoProducao = e.target.value
            setTipoProducao(e.target.value === "" ? null : e.target.value)
        },
        [item]
    )
    const [anchorRecomendacaoCfop, setAnchorRecomendacaoCfop] = useState(null)

    const [removiImagem, setRemoviImagem] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const [open, setOpen] = useState(false)
    const openMoreProduto = Boolean(anchorEl)
    const handleClickMoreProduto = useCallback(event => {
        setAnchorEl(event.currentTarget)
    }, [])

    const handleCloseMoreProduto = useCallback(() => {
        setAnchorEl(null)
    }, [])

    return (
        <>
            <Dialog
                open={open}
                onClose={() => {
                    setOpen(false)
                    setAltInsumo(false)
                }}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle>Editar Ficha Técnica</DialogTitle>
                <DialogContent>
                    <DialogFTI
                        insumos={insumos}
                        insumoSelecionado={insumoSelecionado}
                        insumosSelecionados={insumosSelecionados}
                        fichaTecnica={fichaTecnica}
                        quantidades={quantidades}
                        handleAddInsumo={handleAddInsumo}
                        handleDeleteInsumo={handleDeleteInsumo}
                        setInsumoSelecionado={setInsumoSelecionado}
                        setQuantidades={setQuantidades}
                        setAltInsumo={setAltInsumo}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        style={{ backgroundColor: "red", color: "white" }}
                        onClick={() => {
                            setOpen(false)
                            setAltInsumo(false)
                        }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        style={{ backgroundColor: "green", color: "white" }}
                        onClick={() => {
                            salvarFt(null, item.id)
                            setOpen(false)
                        }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
            <Grid container alignItems="center">
                <Grid
                    item
                    container
                    justifyContent="center"
                    alignItems="center"
                    className={classes.containerImg}
                    onClick={handleDivClick}
                    style={{ position: "relative" }}
                >
                    {item.urlImagem && !removiImagem ? (
                        <Grid>
                            <img
                                style={{
                                    borderRadius: "10px",
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    objectPosition: "center",
                                }}
                                loading="lazy"
                                src={item.urlImagem}
                                height={"90px"}
                                alt=""
                            />
                        </Grid>
                    ) : (
                        <Grid>
                            <AddAPhoto className={classes.addAPhoto} />
                        </Grid>
                    )}
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        className={classes.input}
                        accept="image/*"
                    />
                    {item.urlImagem && (
                        <div
                            style={{
                                position: "absolute",
                                top: "-1px",
                                left: "calc(50% + 50px)",
                            }}
                        >
                            <IconButton
                                size="small"
                                onClick={e => {
                                    e.stopPropagation()
                                    handleIdsEditar(produto.id)
                                    item.urlImagem = ""
                                    setRemoviImagem(true)
                                }}
                            >
                                <DeleteForever style={{ color: "red" }} fontSize="small" />
                            </IconButton>
                        </div>
                    )}
                </Grid>
                <Grid
                    item
                    container
                    spacing={1}
                    xs={12}
                    sm={12}
                    md={10}
                    className={classes.conteudo}
                >
                    <Grid item container xs={12} sm={12} md={1}>
                        <TextField
                            fullWidth
                            type="number"
                            variant="outlined"
                            label="Exibição"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            defaultValue={item.ordemExib}
                            onChange={e => {
                                handleIdsEditar(produto.id)
                                item.ordemExib = e.target?.value
                            }}
                        />
                    </Grid>
                    <Grid item container xs={12} sm={12} md={5}>
                        <TextField
                            fullWidth
                            type="text"
                            variant="outlined"
                            label="Nome"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            defaultValue={item.nome.replace("Nova opção", "").trim()}
                            onChange={e => {
                                handleIdsEditar(produto.id)
                                item.nome = e.target.value.replace("Nova opção", "").trim()
                            }}
                        />
                    </Grid>
                    <Grid item container xs={12} sm={12} md={3}>
                        <TextField
                            type="number"
                            fullWidth
                            size="small"
                            variant="outlined"
                            label="Preço"
                            InputLabelProps={{ shrink: true }}
                            defaultValue={item.valor}
                            onChange={e => {
                                handleIdsEditar(produto.id)
                                item.valor = Number(e.target?.value)
                            }}
                        />
                    </Grid>
                    <Grid item container xs={12} sm={12} md={3}>
                        <TextField
                            fullWidth
                            type="number"
                            variant="outlined"
                            label="Código PDV"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            defaultValue={item.codigo}
                            onChange={e => {
                                handleIdsEditar(produto.id)
                                item.codigo = e.target?.value
                            }}
                        />
                    </Grid>

                    <Grid item container xs={12} sm={12} md={6}>
                        <TextField
                            multiline
                            fullWidth
                            type="text"
                            variant="outlined"
                            label="Descrição"
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            defaultValue={item.descricao}
                            onChange={e => {
                                handleIdsEditar(produto.id)
                                item.descricao = e.target?.value
                            }}
                        />
                    </Grid>
                    <Grid item container xs={12} sm={12} md={3}>
                        <FormControl
                            size="small"
                            fullWidth
                            variant="outlined"
                            disabled={!parametros.impressaoAlternada}
                        >
                            <InputLabel>Impressora</InputLabel>
                            <Select
                                label="Impressora"
                                defaultValue={
                                    parametros.impressaoAlternada ? item.impressaoAlternada : 0
                                }
                                onChange={e => {
                                    handleIdsEditar(produto.id)
                                    item.impressaoAlternada = e.target.value
                                }}
                            >
                                <MenuItem value={0}> - </MenuItem>
                                <MenuItem value={1}> 1ª impressora</MenuItem>
                                <MenuItem value={2}> 2ª impressora</MenuItem>
                                <MenuItem value={3}> 3ª impressora</MenuItem>
                                <MenuItem value={4}> 4ª impressora</MenuItem>
                                <MenuItem value={5}> 5ª impressora</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item container xs={12} sm={12} md={3}>
                        <Button
                            fullWidth
                            className={classes.botaoExcluir}
                            onClick={() => {
                                handleExcluirOpcao(produto.id, passo.id, item.id)
                            }}
                        >
                            Excluir
                        </Button>
                    </Grid>
                    <Grid item container xs={12} sm={12} md={6} alignItems="center">
                        <FormControl
                            style={{
                                padding: 0,
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            <Typography style={{ fontWeight: "bold" }}>CFOP:</Typography>
                            <IconButton
                                size="small"
                                aria-label="Recomendações de CFOP"
                                onClick={e => setAnchorRecomendacaoCfop(e.currentTarget)}
                            >
                                <InfoOutlined fontSize="small" />
                            </IconButton>
                            <RadioGroup
                                style={{
                                    padding: 0,
                                    marginLeft: "1em",
                                }}
                                row
                                value={tipoProducao}
                                onChange={e => {
                                    handleIdsEditar(produto.id)
                                    handleTipoProducao(e)
                                }}
                            >
                                <FormControlLabel
                                    style={{ padding: 0 }}
                                    value={null}
                                    control={<Radio style={{ padding: 0 }} />}
                                    label="Automático"
                                />
                                <FormControlLabel
                                    style={{ padding: 0 }}
                                    value="5101"
                                    control={<Radio style={{ padding: 0 }} />}
                                    label="Produção própria (5101)"
                                />
                                <FormControlLabel
                                    style={{ padding: 0 }}
                                    value="5102"
                                    control={<Radio style={{ padding: 0 }} />}
                                    label="Revenda sem ST (5102)"
                                />
                                <FormControlLabel
                                    style={{ padding: 0 }}
                                    value="5405"
                                    control={<Radio style={{ padding: 0 }} />}
                                    label="Revenda com ST (5405)"
                                />
                            </RadioGroup>
                            <Popover
                                open={Boolean(anchorRecomendacaoCfop)}
                                anchorEl={anchorRecomendacaoCfop}
                                onClose={() => setAnchorRecomendacaoCfop(null)}
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                transformOrigin={{ vertical: "top", horizontal: "left" }}
                            >
                                <div style={{ padding: "1em", maxWidth: "360px" }}>
                                    <Typography
                                        variant="subtitle2"
                                        style={{ marginBottom: "0.5em" }}
                                    >
                                        Recomendações de CFOP
                                    </Typography>
                                    <Typography variant="body2" style={{ marginBottom: "0.5em" }}>
                                        <strong>Automático:</strong> deixa o sistema decidir pelo
                                        nome do item (bebida vira revenda; os demais, produção
                                        própria).
                                    </Typography>
                                    <Typography variant="body2" style={{ marginBottom: "0.5em" }}>
                                        <strong>Produção própria (5101):</strong> produtos
                                        preparados ou fabricados pela própria loja.
                                    </Typography>
                                    <Typography variant="body2" style={{ marginBottom: "0.5em" }}>
                                        <strong>Revenda sem ST (5102):</strong> produtos comprados
                                        prontos e revendidos, sem substituição tributária.
                                    </Typography>
                                    <Typography variant="body2">
                                        <strong>Revenda com ST (5405):</strong> produtos revendidos
                                        com substituição tributária (ex.: bebidas).
                                    </Typography>
                                </div>
                            </Popover>
                        </FormControl>
                    </Grid>
                    <Grid item container xs={12} sm={12} md={3} alignItems="center">
                        <Checkbox
                            defaultChecked={item.informativo}
                            onChange={e => {
                                handleIdsEditar(produto.id)
                                item.informativo = e.target.checked
                            }}
                        />
                        <Typography>Apenas Informativo</Typography>
                    </Grid>
                    <Grid
                        item
                        container
                        xs={12}
                        sm={10}
                        md={2}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <DisponibilidadeSwitch
                            disponivel={disponivel}
                            handleChangeDisponibilidadeOpcao={handleChangeDisponibilidadeOpcao}
                        />
                    </Grid>
                    <Grid
                        item
                        container
                        xs={12}
                        sm={2}
                        md={1}
                        alignItems="center"
                        justifyContent="center"
                    >
                        <IconButton size="small" onClick={handleClickMoreProduto}>
                            <MoreVert />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={openMoreProduto}
                            onClose={handleCloseMoreProduto}
                        >
                            <MenuItem
                                onClick={async () => {
                                    await buscarFT("opcao", null, item.id)
                                    setOpen(true)
                                }}
                            >
                                Editar Ficha Técnica
                            </MenuItem>
                        </Menu>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
})

export default ItemAdicional
